module.exports = __webpack_public_path__ + "static/media/passport.dc6e57da.svg";